import React, { FC } from 'react';
import { NativeProps, withNativeProps } from '../utils/native-props';
import { mergeProps } from '../utils/with-default-props';
import { usePropsValue } from '../utils/use-props-value';
import CheckListContext from './context';

import styles from './check-list.module.scss';

export type CheckListProps = {
  defaultValue?: string[];
  value?: string[];
  onChange?: (val: string[]) => void;
  multiple?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  mode?: string;
} & NativeProps;

const defaultProps = {
  multiple: false,
  defaultValue: [],
};

export const CheckList: FC<CheckListProps> = (p) => {
  const props = mergeProps(defaultProps, p);

  const [value, setValue] = usePropsValue(props);

  function check(val: string) {
    if (props.multiple) {
      setValue([...value, val]);
    } else {
      setValue([val]);
    }
  }

  function uncheck(val: string) {
    setValue(value.filter((item) => item !== val));
  }

  const { disabled, readOnly, mode } = props;

  return (
    <CheckListContext.Provider
      value={{
        value,
        check,
        uncheck,
        disabled,
        readOnly,
        mode,
      }}
    >
      {withNativeProps(props, <div className={styles.list}>{props.children}</div>)}
    </CheckListContext.Provider>
  );
};
